import { FileText, Video, Music, LucideIcon } from 'lucide-react'

const config: Record<string, { label: string; icon: LucideIcon; bg: string; text: string }> = {
  text: { label: '图文', icon: FileText, bg: 'bg-blue-100', text: 'text-blue-600' },
  video: { label: '视频', icon: Video, bg: 'bg-purple-100', text: 'text-purple-600' },
  audio: { label: '音频', icon: Music, bg: 'bg-orange-100', text: 'text-orange-600' },
}

interface MediaTypeBadgeProps {
  type: 'text' | 'video' | 'audio'
  size?: 'sm' | 'md'
  showIcon?: boolean
}

const MediaTypeBadge = ({ type, size = 'sm', showIcon = true }: MediaTypeBadge) => {
  const cfg = config[type] || config.text
  const Icon = cfg.icon
  const sizeCls = size === 'sm' ? 'text-xs px-2 py-0.5' : 'text-sm px-2.5 py-1'
  return (
    <span className={`inline-flex items-center gap-1 rounded-full ${cfg.bg} ${cfg.text} ${sizeCls}`}>
      {showIcon && <Icon className={size === 'sm' ? 'w-3 h-3' : 'w-4 h-4'} />}
      {cfg.label}
    </span>
  )
}

export default MediaTypeBadge
